import React from "react";
import { useSelector } from "react-redux";
import { getUserData } from "../../Redux/UserSlice";

const FlowCompleteTY = ({ languageContent }) => {
  const user = useSelector(getUserData);
  return (
    <>
      <img src="./like.png" alt="Like image" />
      <div className="heading">
        <p>{languageContent.thank_you_page.thank_you_title}</p>
      </div>
      <p>
        {languageContent.thank_you_page.message2}&nbsp;
        {languageContent.thank_you_page.message3}
        {user.application_number}
      </p>
    </>
  );
};

export default FlowCompleteTY;
